<!--All Roles for the selected school-->
<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstRoles"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedRoles"
		dataKey="RoleID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--Selected-->

				<th>
					<p-columnFilter type="text" field="RoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="UserLevelDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="RoleDesc">Role<p-sortIcon field="RoleDesc"></p-sortIcon></th>
				<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-role>
			<tr [pSelectableRow]="role" [pTooltip]="role.ToolTip" tooltipPosition="bottom" showDelay="500" hideDelay="125">
				<td>
					<p-tableCheckbox [pSelectableRow]="role" [value]="role"></p-tableCheckbox>
				</td>

				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="role.DefinedByID == 1 ? 'Red' : 'Black'"
				>
					{{ role[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
